module.exports = __webpack_public_path__ + "img/icon_grid_upp.c94f3ad3.svg";